/** */
import {
  ADD_MANY_LOGS_TO_STORE,
  ADD_ONE_LOG_TO_STORE,
  ADD_SEARCH_RESULTS_TO_STORE,
  LOAD_LOGS_TO_STORE,
  REM_ONE_LOG_FROM_STORE
} from '../actions/log';

export default (state = {}, action) => {
  const { type, payload } = action;
  let previous_state;
  switch (type) {
    case ADD_MANY_LOGS_TO_STORE:
      return {
        ...state,
        ...payload.reduce(
          (logs, log) => ({
            ...logs,
            [log.id]: log
          }),
          {}
        )
      };
    case ADD_ONE_LOG_TO_STORE:
      return {
        ...state,
        [payload.id]: payload
      };
    case ADD_SEARCH_RESULTS_TO_STORE:
      return {
        ...payload.reduce(
          (logs, log) => ({
            ...logs,
            [log.id]: log
          }),
          {}
        )
      };
    case LOAD_LOGS_TO_STORE:
      return {
        ...payload.reduce(
          (logs, log) => ({
            ...logs,
            [log.id]: log
          }),
          {}
        )
      };
    case REM_ONE_LOG_FROM_STORE:
      previous_state = { ...state };
      delete previous_state[payload];
      return {
        ...previous_state
      };
    default:
      return state;
  }
};
